<script>

export default {
  name:'simulraccomodalcontent',
  props: [],
  data() {
    return {
      isConso:false,
      isProdAndconso:false,
      isProd:false,
      isAddProdOnConso:false,
    }
  },
  beforeMount(){
    this.isProd=true;
  },
  mounted(){
   
  },
  methods: {
    close() {
      this.$emit('close');
    },
    /**
     * Ajoute l'option pour la sélection du type de vente
     */
    prodEtConso(){
      this.unbindAll();
      this.isProdAndconso=true;
    },
    /**
     * Ajoute l'option pour la sélection du type de vente et du type de raccordement
     */
    addProdOnConso(){
      this.unbindAll();
      //this.isProdAndconso=true;
      this.isAddProdOnConso=true;
    },
    conso(){
      this.unbindAll();
      this.isConso=true;
    },
    prod(){
      this.unbindAll();
      this.isProd=true;
    },
    unbindAll(){
      this.isConso=false,
      this.isProdAndconso=false,
      this.isProd=false,
      this.isAddProdOnConso=false
    },
  }
}
</script>

<template>
  <div class="modal" id="divModalRacco">
    <div class="dark-panel col-md-7 col-md-offset-2" >
      <header class="modal-header">
        <slot name="header">
          <h1>Simulation des options de raccordements</h1>
        </slot>
        <button type="button" class="btn-close" @click="close"> x </button>
      </header>
      <section class="modal-body">
        <slot name="body">
          <fieldset>
            <div class="container">
              <div class="row">
                <div class="col-6 ">
                  <div class="input-group" id="divUsage">
                    <label class="legend"><h3>Usage :</h3></label>

                    <div class="row col-md-12">
                        <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1"  id="prod" name="usage" value="Production" checked @click="prod()">
                        <label class="input-group-text col-md-offset-1" for="prod"><h5>Production</h5></label>
                    </div>
            
                    <div class="row col-md-12">
                      <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1"  id="conso" name="usage" value="Consumption" required @click="conso()">
                      <label class="input-group-text  col-md-offset-1" for="conso"><h5>Consommation</h5></label>                         
                    </div>
                    
                    <div class="row col-md-12">
                      <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1"  id="prodAndconso" name="usage" value="ConsumptionAndProduction" @click="prodEtConso()">
                      <label class="input-group-text col-md-offset-1" for="prodAndconso"><h4>Production et Consommation</h4></label>
                    </div>

                    <div class="row col-md-12">
                      <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1"  id="addProdOnConso" name="usage" value="ProductionOverConsumption" @click="addProdOnConso()">
                      <label class="input-group-text col-md-offset-1" for="addProdOnConso"><h4>Ajout de Production sur consommation</h4></label>
                    </div>

                  </div>
                </div>
                <div class="col-6">
                  <div class="input-group" id="divParcelle">
                    <label class="legend"><h3>Parcelle viabilisée ?</h3></label>

                    <div class="row col-md-12">
                      <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1"  id="parcelle_oui" name="serviced_plot" value="true" required>
                      <label class="input-group-text  col-md-offset-1" for="parcelle_oui"><h5> Oui</h5></label>                         
                    </div>

                    <div class="row col-md-12">
                      <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1"  id="parcelle_non" name="serviced_plot" value="false">
                      <label class="input-group-text  col-md-offset-1" for="parcelle_non"><h5>Non</h5></label>                         
                    </div>

                  </div>
                </div> 
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="input-group" id="typeDeVente">
                    <label class="legend"><h3>Puissance (kWc):</h3></label>

                    <div v-if='isProdAndconso | isProd | isAddProdOnConso' class="row col-md-12">
                      <label class="input-group-text col-md-4" for="prodAndConsoInjected"><h4> Puissance injectée : </h4></label>
                      <input type="number" class="form-control number col-md-2" aria-describedby="basic-addon1" id="prodAndConsoInjected" name="injected_power" required value="">
                    </div>

                    <div v-if='isProdAndconso | isConso' class="row col-md-12">
                      <label class="input-group-text col-md-4" for="prodAndConsoSubscribed"><h4>Puissance souscrite :</h4></label>
                      <input type="number" class=" form-control number  col-md-2" aria-describedby="basic-addon1" id="prodAndConsoSubscribed" name="subscribed_power" required value="">
                    </div>

                  </div>
                </div>
                <div class="col-6">
                  <div v-if='isProdAndconso | isAddProdOnConso' >
                    <div class="input-group" id="typeDeVente">
                      <label class="legend"><h3>Type de vente :</h3></label>
                  
                      <div class="row col-md-12">
                        <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1" id="prodAndConsoSurplus" name="sales_strategy" required value="Surplus">
                        <label class="input-group-text col-md-offset-1" for="prodAndConsoSurplus"><h4>Surplus</h4></label>
                      </div>

                      <div class="row col-md-12">
                        <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1" id="prodAndConsoTotality" name="sales_strategy" value="Totality">
                        <label class="input-group-text col-md-offset-1" for="prodAndConsoTotality"><h4>Totalité</h4></label>
                      </div>

                    </div>
                  </div>
                </div>
                
              </div>
              <div class="row">
                <div class="col-6">
                  <div v-if='isAddProdOnConso'>
                    <div class="input-group" id="typeRacco">
                      <label class="legend"><h3>Type de raccordement :</h3></label>
                      
                      <div class="row col-md-12">
                        <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1" id="AddProdOnConsoSurplus" name="installed_phase" required value="AN">
                        <label class="input-group-text col-md-offset-1" for="prodAndConsoSurplus"><h4>Monophasé (AN)</h4></label>
                      </div>
                      
                      <div class="row col-md-12">
                        <input type="radio" class="form-control col-md-4" aria-describedby="basic-addon1" id="AddProdOnConsoTotality" name="installed_phase" value="ABCN">
                        <label class="input-group-text col-md-offset-1" for="prodAndConsoTotality"><h4>Triphasé (ABCN)</h4></label>
                      </div>   
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </fieldset>
        </slot>
      </section>
      <footer>
        <div class="row col-md-12">
          <div class="col-md-11 ">
            <button type="button" class="btn btn-primary btn-footer-modal text-blue_claire" @click="close">
              {{trans.get('common.cancel')}}
            </button>
          </div>
          <div class="btn-footer-modal col-md-1">
            <button type="submit" class="buttonOriginal" :title="trans.get('common.save')">
              <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span>
            </button>
          </div>             
        </div> 
      </footer>
    </div>
   </div>  
</template>

<style scoped>
  .modal {
    box-shadow :none;
    position:fixed;
    top: 30%;
    left: 33%;
    z-index: 1050;
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    border-color: #fff;
  }
  .dark-panel  {
    color: white;
    display: block;
    width: auto;
    height: auto;
    overflow: hidden;
    word-break: break-all;
  }
  .input-group-text {
    display: inline-flex;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 1rem;
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    justify-content: center;
  }
  .form-control {
    display: inline-flex;
    width: 100%;
    height: calc(1.6em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.7rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .legend {
      margin-left:20%;
  }
  .btn-footer-modal{
    margin-bottom:0.5rem;
  }
  .number{
    font-size: 1.2rem;
    margin-left: 15%;
  }

</style>
